import "./review-votes.scss"

class ReviewVotes {
  constructor(el, className) {
    this.el = el
    this.reviewId = parseInt(this.el.dataset.reviewId, 10)
    this.className = className
    this.upvotedModifier = `${this.className}--upvoted`
    this.downvotedModifier = `${this.className}--downvoted`
    this.upvotesCountClass = `${this.className}__upvotes-count`
    this.downvotesCountClass = `${this.className}__downvotes-count`
  }

  init() {
    const upvote = this.el.querySelector(".review-votes__upvote")
    upvote.addEventListener("click", (e) => {
      e.preventDefault()
      this.upvote()
    })

    const downvote = this.el.querySelector(".review-votes__downvote")
    downvote.addEventListener("click", (e) => {
      e.preventDefault()
      this.downvote()
    })
  }

  upvote() {
    if (this.upvoted()) {
      this.modifyUpvotes(-1)
      this.sendVote(+1, { cancel: true })
    } else {
      if (this.downvoted()) {
        this.modifyDownvotes(-1)
      }
      this.modifyUpvotes(+1)
      this.sendVote(+1)
    }

    this.toggleClass(this.upvotedModifier)
    this.removeClass(this.downvotedModifier)
  }

  downvote() {
    if (this.downvoted()) {
      this.modifyDownvotes(-1)
      this.sendVote(-1, { cancel: true })
    } else {
      if (this.upvoted()) {
        this.modifyUpvotes(-1)
      }
      this.modifyDownvotes(+1)
      this.sendVote(-1)
    }

    this.toggleClass(this.downvotedModifier)
    this.removeClass(this.upvotedModifier)
  }

  sendVote(value, { cancel = false } = {}) {
    const meta = document.querySelector("meta[name=csrf-token]")
    const token = meta ? meta.content : ""

    fetch(`/reviews/${this.reviewId}/review_vote`, {
      method: cancel ? "DELETE" : "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
      },
      body: JSON.stringify({ review_vote: { value } }),
    })
  }

  modifyUpvotes(diff) {
    const upvotes = this.el.querySelector(`.${this.upvotesCountClass}`)
    upvotes.innerHTML = parseInt(upvotes.innerHTML, 10) + diff
  }

  modifyDownvotes(diff) {
    const upvotes = this.el.querySelector(`.${this.downvotesCountClass}`)
    upvotes.innerHTML = parseInt(upvotes.innerHTML, 10) + diff
  }

  upvoted() {
    return this.el.classList.contains(this.upvotedModifier)
  }

  downvoted() {
    return this.el.classList.contains(this.downvotedModifier)
  }

  toggleClass(className) {
    this.el.classList.toggle(className)
  }

  removeClass(className) {
    this.el.classList.remove(className)
  }
}

export default function setListeners() {
  const className = "review-votes"
  const selector = `.${className}:not(.${className}--disabled)`

  ;[...document.querySelectorAll(selector)].forEach((el) => {
    const reviewVotes = new ReviewVotes(el, className)
    reviewVotes.init()
  })
}
